import { type DependencyList, type RefObject, useLayoutEffect, useState } from 'react';

export type HasVerticalScrollbarResult = {
  hasVerticalScroll: boolean;
  scrollbarWidth: number;
};

/** overflow-y: auto 요소의 세로 스크롤 여부와 스크롤바 너비 (offsetWidth - clientWidth) */
export function useHasVerticalScrollbar<T extends HTMLElement>(
  ref: RefObject<T | null>,
  deps: DependencyList
): HasVerticalScrollbarResult {
  const [state, setState] = useState<HasVerticalScrollbarResult>({
    hasVerticalScroll: false,
    scrollbarWidth: 0,
  });

  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;

    const update = () => {
      const hasScroll = el.scrollHeight > el.clientHeight + 0.5;
      const scrollbarWidth = hasScroll ? Math.max(0, el.offsetWidth - el.clientWidth) : 0;
      setState({ hasVerticalScroll: hasScroll, scrollbarWidth });
    };

    update();

    const ro = new ResizeObserver(update);
    ro.observe(el);

    return () => ro.disconnect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ref, ...deps]);

  return state;
}
